import React from 'react';
import Icon from '../../../components/AppIcon';

const EventSchedule = ({ schedule }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <h2 className="text-2xl font-bold text-[var(--color-foreground)]">Event Schedule</h2>
      <div className="space-y-4">
        {schedule?.map((item, index) => (
          <div key={index} className="relative pl-8 pb-8 last:pb-0">
            {index !== schedule?.length - 1 && (
              <div className="absolute left-3 top-8 bottom-0 w-0.5 bg-[var(--color-border)]" />
            )}
            
            <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-[var(--color-primary)] flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-white" />
            </div>
            
            <div className="bg-[var(--color-muted)] rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-semibold text-[var(--color-primary)]">{item?.time}</span>
                <span className="text-xs text-[var(--color-muted-foreground)]">{item?.duration}</span>
              </div>
              <h4 className="font-semibold text-[var(--color-foreground)] mb-1">{item?.activity}</h4>
              <p className="text-sm text-[var(--color-muted-foreground)]">{item?.description}</p>
              {item?.location && (
                <div className="flex items-center gap-2 mt-2 text-sm text-[var(--color-muted-foreground)]">
                  <Icon name="MapPin" size={14} />
                  <span>{item?.location}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventSchedule;